import React, { useContext, useEffect, useState } from "react";
import { axiosUrl } from "../../api/axios";
import { UserContext } from "../../App";
import WithdrawComp from "../../components/Dashboard/WithdrawComp";
import DashboardLayout from "../../layouts/DashboardLayout";

const Withdraw = () => {
  const { userData } = useContext(UserContext);
  const [withdrawComp, setWithdrawComp] = useState(false);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    axiosUrl.get("/transactions").then((response) => setHistory(response.data));
  }, []);

  return (
    <DashboardLayout>
      <div className="withdraw">
        <h3 className="title-text sharp-text">Withdraw</h3>

        <div className="top-nav">
          <button
            className="btn rounded"
            onClick={() => setWithdrawComp(!withdrawComp)}
          >
            <i className="fas fa-credit-card"></i>
            <p className="sharp-text">Request For Withdrawal</p>
          </button>
        </div>

        <div className={`withdraw-comp ${withdrawComp ? "show-withdraw" : ""}`}>
          <WithdrawComp
            setWithdrawComp={setWithdrawComp}
            withdrawComp={withdrawComp}
          />
        </div>

        <h6 className="title-text mt-3 mx-3">Withdrawal History</h6>
        <div className="recent-withdrawals">
          <ul>
            <li className="list-title">
              <p className="sharp-text">Amount</p>
              <p className="sharp-text">Mode</p>
              <p className="sharp-text">Status</p>
              <p className="sharp-text">Date</p>
            </li>
            <hr />
            {history &&
              history
                .filter(
                  (history) =>
                    history.type === "Withdrawal" &&
                    history.userId === userData.user.id
                )
                .map((history) => {
                  return (
                    <li key={history._id} className="recent-withdrawal">
                      <p className="sharp-text">{history.amount}</p>
                      <p className="sharp-text">{history.mode}</p>
                      <p
                        className="sharp-text"
                        style={{
                          color: history.status === true ? "green" : "red",
                        }}
                      >
                        {history.status === true ? "Completed" : "Pending"}
                      </p>
                      <p className="sharp-text">{history.date.slice(0, 10)}</p>
                    </li>
                  );
                })}
          </ul>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Withdraw;
